import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { richTextToPlainText } from '../../../lib/richText';

const HolderList = ({ holders, onEdit, onDelete }) => (
  <div className="bg-white rounded-lg shadow-lg p-6" data-testid="holders-list">
    <h2 className="text-xl font-bold mb-4">All Record Holders ({holders.length})</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {holders.map((holder) => (
        <div key={holder.id} className="border rounded-lg p-4" data-testid={`holder-card-${holder.id}`}>
          <h3 className="font-bold text-lg mb-2">{holder.name}</h3>
          <div className="flex gap-2 mb-2 overflow-x-auto">
            {holder.images &&
              holder.images.map((img) => (
                <img
                  key={img}
                  src={img}
                  alt=""
                  className="w-20 h-20 object-cover rounded"
                />
              ))}
          </div>
          <p className="line-clamp-3 text-sm text-gray-600 mb-3">
            {richTextToPlainText(holder.achievement)}
          </p>
          <div className="flex gap-2">
            <Button
              onClick={() => onEdit(holder)}
              data-testid={`edit-holder-${holder.id}`}
              variant="outline"
              className="flex-1 text-blue-600 hover:bg-blue-50 flex items-center justify-center gap-2"
            >
              <Edit size={16} />
              Edit
            </Button>
            <Button
              onClick={() => onDelete(holder.id)}
              data-testid={`delete-holder-${holder.id}`}
              variant="outline"
              className="flex-1 text-red-600 hover:bg-red-50 flex items-center justify-center gap-2"
            >
              <Trash2 size={16} />
              Delete
            </Button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default HolderList;
